
// BlogPostPage.tsx - Atualizado para usar o novo sistema Front Matter CMS
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import BlogPost from '@/components/blog/BlogPost';

/**
 * BlogPostPage - Página individual de post do blog
 *
 * SEO é gerenciado internamente pelo componente BlogPost
 * (BlogPostTraditional/BlogPostWithVideo) usando Helmet, JSON-LD e Open Graph.
 */
const BlogPostPage = () => {
  return (
    <>
      <Navbar />
      <main className="pt-20">
        <BlogPost />
      </main>
      <Footer />
    </>
  );
};

export default BlogPostPage;
